import React from "react";
import {PracticeSimulatorWorkspace} from "./PracticeSimulatorPage";
import useStudyBuddyIframeHeight from "./useStudyBuddyIframeHeight";

export default function PracticeSimulatorEmbedPage(){const heightRef=useStudyBuddyIframeHeight();return <div ref={heightRef}><PracticeSimulatorWorkspace embed/></div>;}
